// extracted by mini-css-extract-plugin
var _1 = "QfywKVsh";
var _2 = "QfywKVsh";
var _3 = "SeFRvCFQ";
var _4 = "gSzVyerq";
var _5 = "gSzVyerq";
export { _1 as "only-desktop", _2 as "onlyDesktop", _3 as "product", _4 as "section-grey", _5 as "sectionGrey" }
